import { toast } from "sonner";
import { userService } from "../services/user.service";
const { getUserById } = userService;

const useAdmin = () => {
  const handleUserSelect = async (selectedUser, onUserSelectSuccess) => {
    try {
      const data = await getUserById(selectedUser.id);
      onUserSelectSuccess(data); // Pass data to a callback to set user form state
    } catch (e) {
      toast.error(e.message || "Falha ao conectar à API ao buscar usuário.");
    }
  };

  return {
    handleUserSelect,
  };
};

export default useAdmin;
